const AppConfig = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
  TENANT_ID: process.env.REACT_APP_TENANT_ID,
  DESKTOP_APP: process.env.REACT_APP_DESKTOP_APP,
};

export default AppConfig;
